import { Injectable, Inject } from '@angular/core';
import { CoreEffects } from '../../../state/effect/core.effects';
import { APP_SETTINGS } from '../../../../modules/ng-express-engine/tokens';

@Injectable()
export class InternalStateHelperService {

    constructor(
        protected coreEffects: CoreEffects,
        @Inject(APP_SETTINGS) private settings: Object
    ) { }


    public setActivePath(state: Object) {
        this.coreEffects.setInternalStateValue("activePath", state);
    }

    public getPopState(){
        return this.coreEffects.getPopState();
    }

    public setDescendantActive(slugIdentifier: string, isActive: boolean) {
        this.setDescendantProp(slugIdentifier, 'isActive', isActive);
    }

    public setDescendantSelected(slugIdentifier: string, selectedItem: number) {
        this.setDescendantProp(slugIdentifier, 'selectedItem', selectedItem);
    }

    public getTheNextPage(item) {
        this.coreEffects.dispatchNextSinglePage(item);
    }

    public getExistingMeta(url) {
        const content = this.coreEffects.getStaticRouteDataByUrl(url);
        if (content['meta']) {
            return content['meta'];
        }
        else {
            return null;
        }
    }

    public setDescendantProps(slugIdentifier: string, props: object) {
        if (!slugIdentifier) {
            return;
        }
        let state = Object.assign({}, this.getActivePath());
        if (!state['childrenState']) {
            state['childrenState'] = {};
        }
        const currentChildState = (state['childrenState'][slugIdentifier]) ? state['childrenState'][slugIdentifier] : {};
        const self = this;
        Object.keys(props).forEach(function (key) {
            currentChildState[key] = props[key];
        });
        state['childrenState'][slugIdentifier] = currentChildState;
        this.setActivePath(state);
    }

    public setActivePathProp(state: any, key: string, propName: string, propVal: any) {
        if (state.urlKey == key){
            state[propName] = propVal;
            this.setActivePath(state);
            return true;
        }
        return false;
    }

    public setDescendantProp(slugIdentifier: string, propName: string, propVal: any) {
        if (!slugIdentifier) {
            return;
        }
        let state = Object.assign({}, this.getActivePath());
        if (this.setActivePathProp(state, slugIdentifier, propName, propVal)){
            return;
        }
        
        if (!state['childrenState']) {
            state['childrenState'] = {};
        }
        const currentChildState = (state['childrenState'][slugIdentifier]) ? state['childrenState'][slugIdentifier] : {};
        currentChildState[propName] = propVal;
        state['childrenState'][slugIdentifier] = currentChildState;
        this.setActivePath(state);
    }

    public getActivePath() {
        return this.coreEffects.getInternalStateValue("activePath");
    }

    public wasPopped() {
        const popped = this.coreEffects.getInternalStateValue("popState2");
        return (popped) ? true : false;
    }

    public getActivePathHistory() {
        const h = this.coreEffects.getInternalStateValue("activePathHistory");
        return h ? h : [];
    }

    public setActivePathHistory(history: any) {
        this.coreEffects.setInternalStateValue("activePathHistory", history);
    }

    public setRootPageState() {
        this.coreEffects.setInternalStateValue("rootPage", true);
    }

    public resetRootPageState() {
        this.coreEffects.setInternalStateValue("rootPage", false);
    }

    public getNavState() {
        return this.coreEffects.getInternalStateValue("navOpen");
    }

    public setNavState(val: boolean) {
        this.coreEffects.setInternalStateValue("navOpen", val);
    }

    public getRootPageState() {
        return this.coreEffects.getInternalStateValue("rootPage");
    }
    public setPopState(url) {
        const routeUrl = (url == "/") ? "/home-ott" : url;
        this.coreEffects.setPopState2(true, routeUrl);
    }

    public popState(url) {
        const routeUrl = (url == "/") ? "/home-ott" : url;
        let h = this.getActivePathHistory();
        if (h.length > 0) {
            const currentState = h.pop();
            if (currentState.urlKey == routeUrl) {
                this.setActivePath(currentState);
                this.setActivePathHistory([].concat(h));
                return true;
            }
        }
        else {
            return false;
        }
    }

    public pop() {
        let h = this.getActivePathHistory();
        if (h.length > 0) {
            const currentState = h.pop();
            return true;
        }
        return false;
    }

    public setHistoryReplaceFlag(val: boolean) {
        this.coreEffects.setInternalStateValue("replaceStateVal", val);
    }

    public getHistoryReplaceFlag() {
        return this.coreEffects.getInternalStateValue("replaceStateVal");
    }

    public addToHistory(entry?: any) {
        let h = [].concat(this.getActivePathHistory());
        const current = (entry) ? entry : this.getActivePath();
        const isReplace = this.getHistoryReplaceFlag();
        if (isReplace) {
            this.setHistoryReplaceFlag(false);
        }
        else {
            if (h.length > 0){
                const hItem = h[h.length - 1];
                if (hItem.urlKey != current.urlKey){
                    h.push(current);
                }
            }
            else{
                h.push(current);
            }
        }

        this.setActivePathHistory(h);
    }

    public processNextPage(component: any, index: number): void {
        if (!component.item['get_url']) return;

        const meta = this.getExistingMeta(component.item['get_url']);
        if (meta) {
            const currPage = Math.ceil(index / meta['count']);
            if (currPage && currPage == meta['current_page_number']) {
                component.last_page = (component.last_page == 1) ? 2 : component.last_page;
                if (component.last_page <= meta['current_page_number']) {
                    component.last_page = currPage + 1;
                    this.getTheNextPage(meta['next_page_url']);
                }
            }
        }
    }

    public processNextRow(component, index): void {

    }

    /**
     * needs to run ***** AFTER ***** there has been an
     *  incrementation of an interactive component's focusedItemIndex
     **/

    public needsNextRow(component: any, index): boolean {
        let needsNewRow: boolean = false;
        if (index > 0 && component.isFlattened) {
            const prevItemSlug = component.data[index - 1]['meta_slug'];
            const lastItemSlug = component.data[component.data.length - 1]['meta_slug'];
            const thisItemSlug = component.data[index]['meta_slug'];
            const row = component.filterRows.find(obj => { return thisItemSlug == obj.meta.slug });
            const nextRow = component.filterRows[component.filterRows.indexOf(row) + 1]
            if (!nextRow) {
                return false;
            }

            needsNewRow = (thisItemSlug == lastItemSlug && prevItemSlug != thisItemSlug && nextRow.data.length == 0);
        }
        return needsNewRow;
    }


    public needsPrevRow(component: any, index): boolean {
        let needsPrevRow: boolean = false;
        if (index > 0 && component.isFlattened) {
            const firstItemSlug = component.data[0]['meta_slug'];
            const prevItemSlug = component.data[index - 1]['meta_slug'];
            const lastItemSlug = component.data[component.data.length - 1]['meta_slug'];
            const thisItemSlug = component.data[index]['meta_slug'];
            needsPrevRow = (thisItemSlug == firstItemSlug && prevItemSlug != thisItemSlug);
        }
        return needsPrevRow;
    }

    public adjustFlattenedRowItems(item: any, asyncResult: any, component: any, jumpToLoadedContent: boolean): void {
        component.data = asyncResult;
        let newFocusedItem: any;
        let index: number;

        if (jumpToLoadedContent) {
            newFocusedItem = component.data.find(obj => { return obj.meta_slug == item.meta.slug });
        } else {
            newFocusedItem = component.data.find(obj => { return obj.meta_slug == component.focusedItem['meta_slug'] })
        }

        index = newFocusedItem ? component.data.indexOf(newFocusedItem) : 0;

        if (jumpToLoadedContent) {
            component.focusedItemIndex = index;
            component.focusedItem = newFocusedItem ? newFocusedItem : null;
            this.adjustInScopeItems(component, index);
        }
    }

    // public handleFilterRowFocusChanged( component, previousFocusedItem ): void {
    //     //if new focusedItem == previousFocused and if 
    //     //previousFocusedItem != null - since previous will default to null
    //     //there is a need for an update to the filter controller

    //         component.dispatchFilterControllerUpdate();

    // }

    public adjustInScopeItems(component, index) {
        //console.log(component.item);

        this.processNextPage(component, index);

        let unfilledSlots = component.virtualPageSize;
        const leftItemCount = Math.ceil(component.virtualPageSize / 2);
        const lowerBoundaryFactor = leftItemCount - 1;
        let lowerBoundary = (index - lowerBoundaryFactor < 0) ? 0 : (index - lowerBoundaryFactor);
        let k = 0;
        let inScopeCount = 0;
        let leftOver = 0;
        for (let dataRow of component.data) {
            if (k >= lowerBoundary && k < lowerBoundary + (component.virtualPageSize)) {
                dataRow['outOfScope'] = false;
                inScopeCount++;
                unfilledSlots--;
            }
            else {
                const leftPos = component.data.length - k - leftItemCount;
                if (leftPos <= leftItemCount && unfilledSlots > 0) {
                    if (leftPos == unfilledSlots) {
                        dataRow['outOfScope'] = false;
                        inScopeCount++;
                        unfilledSlots--;
                    }
                }
                else {
                    dataRow['outOfScope'] = true;
                }
            }
            k++;
        }

        //if (component.isFlattened) {
            component.inScopeItems = component.data.filter(obj => { return !obj.outOfScope });
        //}
        component.ref.detectChanges();
    }

    public adjustScopeItemsInFlattenedRow(component, index) {
        const focusedItemSlug = component.data[index].meta_slug;
        const filterableItem = component.filterRows.find(obj => { return focusedItemSlug == obj.meta.slug });
        const filterableItemSlug = filterableItem ? filterableItem.meta.slug : null;
        const indexOfNextFilterableItem = component.filterRows.indexOf(filterableItem) + 1;
        const nextFilterableItem = component.filterRows[indexOfNextFilterableItem];
        const needsNextRow = this.needsNextRow(component, index);
        const needsPrevRow = this.needsPrevRow(component, index);
        if (needsNextRow || needsPrevRow) {
            this.adjustInScopeItems(component, index);
            component.updateFilterRow(nextFilterableItem, false);
        } else {
            this.adjustInScopeItems(component, index);
        }
    }
}


// WEBPACK FOOTER //
// ./src/angular-engine/engine/service/ui/internal-state/internal-state.helper.service.ts